import React, {useEffect, useState} from 'react'
import {LocalMallRounded as LocalMallIcon} from '@mui/icons-material'
import {general as textsGeneral} from '../../../translate/Translate.jsx'
import {getLocal} from '../../../hooks/useStorage/useStorage.jsx'
import {IconButton} from '@mui/material'

import './cartButton.scss'

const CartButton = ({isCartButton, onClick}) => {
    const [subtotal, setSubtotal] = useState(0)
    useEffect(() => checkValues(), [isCartButton])

    const checkValues = () => {
        const items = getLocal('items', [])
        if (!!items.length) {
            let subtotal = 0
            items.forEach(item => (subtotal += item.price))
            setSubtotal(subtotal)
        }
    }

    return <div className={'cart-button'}>
        <div className={'container-cart-button'}>
            <div className={'left'}>
                <label className={'label-price'}>
                    {subtotal.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>
            <div className={'button'} onClick={() => onClick()}>
                <label className={'label-add'}>
                    {textsGeneral.seeBag}
                </label>
                <IconButton>
                    <LocalMallIcon className={'icon'}/>
                </IconButton>
            </div>
        </div>
    </div>
}

export default CartButton
